import React from 'react';
import PropTypes from 'prop-types';
import { IntlShape, useIntl } from 'react-intl';
import RelationSearch from '@/shared/components/input/RelationSearch';
import RelationName from '@/shared/components/RelationName';
import { useStateService } from '@/shared/services/StateService';
import FormGroupPart from './FormGroupPart';
import { relationShape } from '../registrationHelpers';
import messages from '../registrationMessages';

const RelationFormGroup = ({
  relation,
  onChange,
  readOnly,
  disabled,
  showValidation,
  autoFocus,
  crmTypes,
  activeOn,
  showOpenRelation,
}) => {
  const intl = useIntl();
  const stateService = useStateService();

  const label =
    showOpenRelation && relation?.id ? (
      <span>
        {intl.formatMessage(messages.Relation)}
        <a
          href={stateService.gotoRelationHref(relation.id)}
          target="_blank"
          rel="noopener noreferrer"
          title={intl.formatMessage(messages.OpenRelation)}
          onClick={e => e.stopPropagation()}
          className="margin5L"
        >
          <i className="fa fa-external-link" />
        </a>
      </span>
    ) : (
      messages.Relation
    );

  return (
    <div className="form-group">
      <FormGroupPart
        label={label}
        inputCols="col-sm-10"
        invalid={showValidation && !readOnly && (!relation || !relation.id)}
      >
        {readOnly ? (
          <p className="form-control-static">
            {relation && <RelationName relation={relation} enabled={false} />}
          </p>
        ) : (
          <RelationSearch
            onChange={onChange}
            initialSelectedItem={relation}
            autoFocus={typeof autoFocus === 'undefined' ? !relation : autoFocus}
            disabled={disabled}
            crmTypes={crmTypes}
            activeOn={activeOn}
            small
          />
        )}
      </FormGroupPart>
    </div>
  );
};
RelationFormGroup.propTypes = {
  relation: relationShape,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  showValidation: PropTypes.bool,
  autoFocus: PropTypes.bool,
  crmTypes: PropTypes.arrayOf(PropTypes.number),
  activeOn: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string, PropTypes.object]),
  showOpenRelation: PropTypes.bool,
};
RelationFormGroup.defaultProps = {
  relation: null,
  onChange: () => {},
  readOnly: false,
  disabled: false,
  showValidation: false,
  autoFocus: undefined,
  crmTypes: [],
  activeOn: null,
  showOpenRelation: false,
};
export default RelationFormGroup;
